"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _framerMotion = require("framer-motion");

var _propTypes = _interopRequireDefault(require("prop-types"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var FG_SIZE = 8;
var BG_SIZE = 9;
var MODAL_Z_INDEX = 999999;

var Card = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Card, _Component);

  var _super = _createSuper(Card);

  function Card() {
    var _this;

    (0, _classCallCheck2["default"])(this, Card);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      hover: false,
      // TODO: need a better way to fix `this.rootRef.current.offsetWidth/Height`
      // value changing during rendering.
      width: 278,
      height: 68,
      visible: false
    };
    _this.margin = 15;
    _this.defaultArrowStyle = {
      color: "#fff",
      borderColor: "rgba(0,0,0,.1)",
      boxShadow: "0 4px 6px 0 rgba(175, 199, 209, 0.4)"
    };
    _this.rootRef = /*#__PURE__*/_react["default"].createRef();

    _this.handleMouseEnter = function () {
      _this.props.active && _this.props.useHover && _this.setState({
        hover: true
      });
    };

    _this.handleMouseLeave = function () {
      _this.setState({
        hover: false
      });
    };

    return _this;
  }

  (0, _createClass2["default"])(Card, [{
    key: "getGlobalStyle",
    value: function getGlobalStyle() {
      var _this2 = this;

      if (!this.props.parentEl) {
        return {
          display: "none"
        };
      }

      var getVisibilityString = function getVisibilityString(visible) {
        return visible ? "visible" : "hidden";
      };

      var getOpacityValue = function getOpacityValue(visible) {
        return visible ? 1 : 0;
      };

      var visible = function () {
        if (!_this2.state.visible) {
          return false;
        }

        return _this2.props.isManualControl ? _this2.props.active : _this2.props.active || _this2.state.hover;
      }();

      var style = _objectSpread({
        position: "absolute",
        marginBottom: "15px",
        background: "rgb(255, 255, 255)",
        borderRadius: "4px",
        boxShadow: "0px 4px 6px rgba(175, 199, 209, 0.4)",
        border: "1px solid rgba(175, 199, 209, 0.5)",
        opacity: getOpacityValue(visible),
        visibility: getVisibilityString(visible),
        // TODO: need to unit z-index(model's z-index is set to be 1040)
        zIndex: MODAL_Z_INDEX
      }, this.getStyle(this.props.position, this.props.arrow));

      return this.mergeStyle(style, this.props.style.style);
    }
  }, {
    key: "getBaseArrowStyle",
    value: function getBaseArrowStyle() {
      return {
        position: "absolute",
        content: '""'
      };
    }
  }, {
    key: "getArrowStyle",
    value: function getArrowStyle() {
      var fgStyle = this.getBaseArrowStyle();
      var bgStyle = this.getBaseArrowStyle();
      fgStyle.zIndex = 60;
      bgStyle.zIndex = 55;

      var arrowStyle = _objectSpread(_objectSpread({}, this.defaultArrowStyle), this.props.style.arrowStyle);

      var bgBorderColor = arrowStyle.borderColor ? arrowStyle.borderColor : "transparent";
      var fgColorBorder = "10px solid ".concat(arrowStyle.color);
      var fgTransBorder = "".concat(FG_SIZE, "px solid transparent");
      var bgColorBorder = "11px solid ".concat(bgBorderColor);
      var bgTransBorder = "".concat(BG_SIZE, "px solid transparent");
      var _this$props = this.props,
          position = _this$props.position,
          arrow = _this$props.arrow;

      if (position === "left" || position === "right") {
        fgStyle.top = "50%";
        fgStyle.borderTop = fgTransBorder;
        fgStyle.borderBottom = fgTransBorder;
        fgStyle.marginTop = -7;
        bgStyle.borderTop = bgTransBorder;
        bgStyle.borderBottom = bgTransBorder;
        bgStyle.top = "50%";
        bgStyle.marginTop = -8;

        if (position === "left") {
          fgStyle.right = -10;
          fgStyle.borderLeft = fgColorBorder;
          bgStyle.right = -11;
          bgStyle.borderLeft = bgColorBorder;
        } else {
          fgStyle.left = -10;
          fgStyle.borderRight = fgColorBorder;
          bgStyle.left = -11;
          bgStyle.borderRight = bgColorBorder;
        }

        if (arrow === "top") {
          fgStyle.top = this.margin;
          bgStyle.top = this.margin;
        }

        if (arrow === "bottom") {
          fgStyle.top = null;
          fgStyle.bottom = this.margin - 7;
          bgStyle.top = null;
          bgStyle.bottom = this.margin - 8;
        }
      } else {
        fgStyle.left = Math.round(this.state.width / 2 - FG_SIZE);
        fgStyle.borderLeft = fgTransBorder;
        fgStyle.borderRight = fgTransBorder;
        fgStyle.marginLeft = 0;
        bgStyle.left = fgStyle.left - 1;
        bgStyle.borderLeft = bgTransBorder;
        bgStyle.borderRight = bgTransBorder;
        bgStyle.marginLeft = 0;

        if (position === "top") {
          fgStyle.bottom = -10;
          fgStyle.borderTop = fgColorBorder;
          bgStyle.bottom = -11;
          bgStyle.borderTop = bgColorBorder;
        } else {
          fgStyle.top = -10;
          fgStyle.borderBottom = fgColorBorder;
          bgStyle.top = -11;
          bgStyle.borderBottom = bgColorBorder;
        }

        if (arrow === "right") {
          fgStyle.left = null;
          fgStyle.right = this.margin + 1 - FG_SIZE;
          bgStyle.left = null;
          bgStyle.right = this.margin - FG_SIZE;
        }

        if (arrow === "left") {
          fgStyle.left = this.margin + 1 - FG_SIZE;
          bgStyle.left = this.margin - FG_SIZE;
        }
      }

      var _this$props$style$arr = this.props.style.arrowStyle,
          color = _this$props$style$arr.color,
          borderColor = _this$props$style$arr.borderColor,
          propsArrowStyle = (0, _objectWithoutProperties2["default"])(_this$props$style$arr, ["color", "borderColor"]);
      return {
        fgStyle: this.mergeStyle(fgStyle, propsArrowStyle),
        bgStyle: this.mergeStyle(bgStyle, propsArrowStyle)
      };
    }
  }, {
    key: "mergeStyle",
    value: function mergeStyle(style, theme) {
      if (theme) {
        var position = theme.position,
            top = theme.top,
            left = theme.left,
            right = theme.right,
            bottom = theme.bottom,
            marginLeft = theme.marginLeft,
            marginRight = theme.marginRight,
            validTheme = (0, _objectWithoutProperties2["default"])(theme, ["position", "top", "left", "right", "bottom", "marginLeft", "marginRight"]);
        return _objectSpread(_objectSpread({}, style), validTheme);
      }

      return style;
    }
  }, {
    key: "getStyle",
    value: function getStyle(position, arrow) {
      var _this3 = this;

      var alignOffset = 0;
      var parent = this.props.parentEl;
      var align = this.props.align;
      var tooltipPosition = parent.getBoundingClientRect();
      var scrollY = window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
      var scrollX = window.scrollX !== undefined ? window.scrollX : window.pageXOffset;

      var _top = scrollY + tooltipPosition.top;

      var _left = scrollX + tooltipPosition.left;

      var style = {};
      var parentSize = {
        width: parent.offsetWidth,
        height: parent.offsetHeight
      }; // fix for svg

      if (!parent.offsetHeight && parent.getBoundingClientRect) {
        parentSize.width = parent.getBoundingClientRect().width;
        parentSize.height = parent.getBoundingClientRect().height;
      }

      if (align === "left") {
        alignOffset = -parentSize.width / 2 + FG_SIZE;
      } else if (align === "right") {
        alignOffset = parentSize.width / 2 - FG_SIZE;
      }

      var stylesFromPosition = {
        left: function left() {
          style.top = _top + parentSize.height / 2 - _this3.state.height / 2;
          style.left = _left - _this3.state.width - _this3.margin;
        },
        right: function right() {
          style.top = _top + parentSize.height / 2 - _this3.state.height / 2;
          style.left = _left + parentSize.width + _this3.margin;
        },
        top: function top() {
          style.left = _left - _this3.state.width / 2 + parentSize.width / 2 + alignOffset;
          style.top = _top - _this3.state.height - 5;
        },
        bottom: function bottom() {
          style.left = _left - _this3.state.width / 2 + parentSize.width / 2 + alignOffset;
          style.top = _top + parentSize.height + 5;
        }
      };
      var stylesFromArrow = {
        left: function left() {
          style.left = _left + parentSize.width / 2 - _this3.margin + alignOffset;
        },
        right: function right() {
          style.left = _left - _this3.state.width + parentSize.width / 2 + _this3.margin + alignOffset;
        },
        top: function top() {
          style.top = _top + parentSize.height / 2 - _this3.margin;
        },
        bottom: function bottom() {
          style.top = _top + parentSize.height / 2 - _this3.state.height + _this3.margin;
        }
      };
      executeFunctionIfExist(stylesFromPosition, position);
      executeFunctionIfExist(stylesFromArrow, arrow);
      return style;
    }
  }, {
    key: "checkWindowPosition",
    value: function checkWindowPosition(style, arrowStyle) {
      if (this.props.position === "top" || this.props.position === "bottom") {
        if (style.left < 0) {
          var parent = this.props.parentEl;

          if (parent) {
            var tooltipWidth = this.state.width;
            var bgStyleRight = arrowStyle.bgStyle.right; // For arrow = center

            if (!bgStyleRight) {
              bgStyleRight = tooltipWidth / 2 - BG_SIZE;
            }

            var newBgRight = Math.round(bgStyleRight - style.left + this.margin);
            arrowStyle = _objectSpread(_objectSpread({}, arrowStyle), {}, {
              bgStyle: _objectSpread(_objectSpread({}, arrowStyle.bgStyle), {}, {
                right: newBgRight,
                left: null
              }),
              fgStyle: _objectSpread(_objectSpread({}, arrowStyle.fgStyle), {}, {
                right: newBgRight + 1,
                left: null
              })
            });
          }

          style.left = this.margin;
        } else {
          var rightOffset = style.left + this.state.width - window.innerWidth;

          if (rightOffset > 0) {
            var originalLeft = style.left;
            style.left = window.innerWidth - this.state.width - this.margin;
            arrowStyle.fgStyle.marginLeft += originalLeft - style.left;
            arrowStyle.bgStyle.marginLeft += originalLeft - style.left;
          }
        }
      }

      if (this.props.contentWidth) {
        style.width = this.props.contentWidth;
      } // TODO: Find a better way to handle `marginBottom` in Firefox


      var pageHeight = document.documentElement.scrollHeight;

      if (style.top > pageHeight - this.state.height - this.margin) {
        style.paddingBottom = "15px";
      }

      return {
        style: style,
        arrowStyle: arrowStyle
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this4 = this;

      this.updateSize();
      setTimeout(function () {
        _this4.updateSize();

        _this4.setState({
          visible: true
        });
      }, 500);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props !== prevProps) {
        this.updateSize();
      }
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var newWidth = this.rootRef.current.offsetWidth;
      var newHeight = this.rootRef.current.offsetHeight;

      if (newWidth !== this.state.width || newHeight !== this.state.height) {
        this.setState({
          width: newWidth,
          height: newHeight
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$checkWindowPosi = this.checkWindowPosition(this.getGlobalStyle(), this.getArrowStyle()),
          style = _this$checkWindowPosi.style;

      var initials = {
        bottom: {
          opacity: 0,
          y: -7
        },
        top: {
          opacity: 0,
          y: 7
        },
        left: {
          opacity: 0,
          x: 7
        },
        right: {
          opacity: 0,
          x: -7
        }
      };
      var initial = initials[this.props.position];
      return /*#__PURE__*/_react["default"].createElement(_framerMotion.AnimatePresence, null, /*#__PURE__*/_react["default"].createElement(_framerMotion.motion.div, {
        initial: initial,
        animate: {
          opacity: 1,
          y: 0,
          x: 0
        },
        transition: {
          duration: 0.3,
          ease: "easeOut"
        },
        exit: initial
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: style,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        ref: this.rootRef
      }, this.props.children)));
    }
  }]);
  return Card;
}(_react.Component);

exports["default"] = Card;
Card.propTypes = {
  active: _propTypes["default"].bool,
  position: _propTypes["default"].oneOf(["top", "right", "bottom", "left"]),
  arrow: _propTypes["default"].oneOf([null, "center", "top", "right", "bottom", "left"]),
  align: _propTypes["default"].oneOf([null, "center", "right", "left"]),
  style: _propTypes["default"].object,
  useHover: _propTypes["default"].bool,
  isManualControl: _propTypes["default"].bool
};
Card.defaultProps = {
  active: false,
  position: "right",
  arrow: null,
  align: null,
  style: {
    style: {},
    arrowStyle: {}
  },
  useHover: true,
  isManualControl: false
};

var executeFunctionIfExist = function executeFunctionIfExist(object, key) {
  if (Object.prototype.hasOwnProperty.call(object, key)) {
    object[key]();
  }
};